import React, { FC } from 'react';
import { Grid } from '@material-ui/core';

import {
  InternalOverviewStats,
  ExternalOverviewStats,
  TotalReachOverviewStats,
  PostOverviewLikeStats,
  PostOverviewShareStats,
  ShareOverviewClickStats,
  ShareOverviewEngagementStats,
  UserOverviewShareStats,
  UserOverviewPostStats,
  GroupOverviewMemberStats,
  GroupOverviewCreatedStats,
  ROIOverviewStats,
} from '../components/Analytics';

import { useReleases } from 'hooks';
import { Capability } from 'components';

const AnalyticsOverview: FC = () => {
  const releases = useReleases();

  return (
    <Grid container direction="column" spacing={4} wrap="nowrap">
      {releases.includes('roi') && (
        <Capability name="Admin.Analytics.ROI.View.Access">
          <Grid item container>
            <Grid item xs={12}>
              <ROIOverviewStats />
            </Grid>
          </Grid>
        </Capability>
      )}
      <Grid item container>
        <Grid item xs={12}>
          <InternalOverviewStats />
        </Grid>
      </Grid>
      <Grid item>
        <Grid container spacing={3}>
          <Grid item xs={8}>
            <ExternalOverviewStats />
          </Grid>
          <Grid item xs={4}>
            <TotalReachOverviewStats />
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <PostOverviewLikeStats />
          </Grid>
          <Grid item xs={6}>
            <PostOverviewShareStats />
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <ShareOverviewClickStats />
          </Grid>
          <Grid item xs={6}>
            <ShareOverviewEngagementStats />
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <UserOverviewShareStats />
          </Grid>
          <Grid item xs={6}>
            <UserOverviewPostStats />
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <GroupOverviewMemberStats />
          </Grid>
          <Grid item xs={6}>
            <GroupOverviewCreatedStats />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AnalyticsOverview;
